import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTypeStringAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 10.75C11.25 9.92157 10.5784 9.25 9.75 9.25C8.92157 9.25 8.25 9.92157 8.25 10.75C8.25 11.3563 8.60974 11.8786 9.12742 12.1151C9.29527 12.1918 9.40437 12.3795 9.32993 12.5483C9.13976 12.9797 8.90835 13.3637 8.68566 13.7332L8.60687 13.8641C8.39376 14.2193 8.50893 14.68 8.86412 14.8931C9.2193 15.1062 9.68 14.9911 9.89311 14.6359C9.92311 14.5859 9.95432 14.5343 9.98649 14.4812C10.674 13.3457 11.25 12.1079 11.25 10.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 9.25C15.0784 9.25 15.75 9.92157 15.75 10.75C15.75 12.1079 15.174 13.3457 14.4865 14.4812C14.4543 14.5343 14.4231 14.5859 14.3931 14.6359C14.18 14.9911 13.7193 15.1062 13.3641 14.8931C13.0089 14.68 12.8938 14.2193 13.1069 13.8641L13.1857 13.7332C13.4084 13.3637 13.6398 12.9797 13.8299 12.5483C13.9044 12.3795 13.7953 12.1918 13.6274 12.1151C13.1097 11.8786 12.75 11.3563 12.75 10.75C12.75 9.92157 13.4216 9.25 14.25 9.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.5 2.75C4.42893 2.75 2.75 4.42893 2.75 6.5V17.5C2.75 19.5711 4.42893 21.25 6.5 21.25H17.5C19.5711 21.25 21.25 19.5711 21.25 17.5V6.5C21.25 4.42893 19.5711 2.75 17.5 2.75H6.5ZM4.25 6.5C4.25 5.25736 5.25736 4.25 6.5 4.25H17.5C18.7426 4.25 19.75 5.25736 19.75 6.5V17.5C19.75 18.7426 18.7426 19.75 17.5 19.75H6.5C5.25736 19.75 4.25 18.7426 4.25 17.5V6.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconTypeStringAlt as ReactComponent };
